"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgSort = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.707 8.707a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0l5.002 5.001a1 1 0 01-1.415 1.414L12 4.414 7.707 8.707zM16.294 15.294a1 1 0 011.415 1.415l-5 5a1 1 0 01-1.415 0l-5.001-5.002a1 1 0 111.414-1.414l4.294 4.294 4.293-4.293z' }))); };
exports.default = SvgSort;
//# sourceMappingURL=Sort.js.map